import { createSelector } from 'reselect';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectResultCatalog = (state: AppStateType) => state.resultCatalog;

export const selectActiveTab = createSelector([selectResultCatalog], state => state.activeTab);

export const selectTabsConfig = createSelector([selectResultCatalog], state => state.tabsConfig);

export const selectIsLoading = createSelector([selectResultCatalog], state => state.isLoading);
